export const adminUsers = {
  'admin.users.title': 'Benutzerverwaltung',
  'admin.users.subtitle': 'Benutzerkonten, Statistiken und Leistung verwalten und überwachen',
  'admin.users.loading': 'Wird geladen...',
  'admin.users.error': 'Fehler beim Laden der Benutzerdaten',
  'admin.users.noData': 'Keine Daten verfügbar',
  'admin.users.cards.totalUsers.title': 'Benutzer Gesamt',
  'admin.users.cards.totalUsers.active': 'Aktiv',
  'admin.users.cards.totalUsers.inactive': 'Inaktiv',
  'admin.users.cards.monthlyUsers.title': 'Neue Benutzer diesen Monat',
  'admin.users.cards.monthlyUsers.dailyRegistrations': 'Heutige Registrierungen',
  'admin.users.cards.usersWithoutAccounts.title': 'Benutzer ohne Konten',
  'admin.users.cards.usersWithoutAccounts.withInactiveAccounts': 'Benutzer mit inaktiven Konten',
  'admin.users.cards.countryDistribution.title': 'Top-Länder',
  'admin.users.cards.countryDistribution.topCountry': 'Top-Land',
  'admin.users.cards.countryDistribution.usersCount': 'Benutzeranzahl',
  'admin.users.cards.countryDistribution.noData': 'Keine Daten verfügbar',
  'admin.users.cards.topEarnersCombined.title': 'Top-Verdiener (Kombiniert)',
  'admin.users.cards.topEarnersCombined.description': 'Trading + Provisions-Gewinne',
  'admin.users.cards.topEarnersAccounts.title': 'Top-Trading-Konto-Verdiener',
  'admin.users.cards.topEarnersAccounts.description': 'Trading-Konto-Gewinne',
  'admin.users.cards.topEarnersCommissions.title': 'Top-Provisions-Verdiener',
  'admin.users.cards.topEarnersCommissions.description': 'Community-Provisions-Gewinne',
  'admin.users.tables.recent.title': 'Neue Benutzer (Letzte 7 Tage)',
  'admin.users.tables.inactive.title': 'Inaktive Benutzer',
  'admin.users.tables.no_accounts.title': 'Benutzer ohne Konten',
  'admin.users.tables.inactive_accounts.title': 'Benutzer mit inaktiven Konten',
  'admin.users.tables.columns.username': 'Benutzername',
  'admin.users.tables.columns.name': 'Name',
  'admin.users.tables.columns.country': 'Land',
  'admin.users.tables.columns.status': 'Status',
  'admin.users.tables.columns.joinedAt': 'Beigetreten am',
  'admin.users.tables.columns.accountCreationDate': 'Kontenerstellung',
  'admin.users.tables.columns.accountNumber': 'Kontonummer',
  'admin.users.tables.columns.accountStatus': 'Kontostatus',
  'admin.users.tables.columns.actions': 'Aktionen',
  'admin.users.tables.status.active': 'Aktiv',
  'admin.users.tables.status.inactive': 'Inaktiv',
  'admin.users.tables.accountStatus.active': 'Aktiv',
  'admin.users.tables.accountStatus.inactive': 'Inaktiv',
  'admin.users.tables.accountStatus.pending': 'Ausstehend',
  'admin.users.tables.accountStatus.suspended': 'Gesperrt',
  'admin.users.tables.accountStatus.closed': 'Geschlossen',
  'admin.users.tables.pagination.previous': 'Zurück',
  'admin.users.tables.pagination.next': 'Weiter',
  'admin.users.tables.pagination.loadMore': 'Mehr laden',
  'admin.users.tables.pagination.showing': 'Zeige',
  'admin.users.tables.pagination.of': 'von',
  'admin.users.tables.pagination.results': 'Ergebnisse',
  'admin.users.tables.pagination.page': 'Seite',
  'admin.users.tables.error': 'Fehler beim Laden der Tabellendaten',
  'admin.users.tables.noData': 'Keine Daten verfügbar',
  'admin.users.tables.noAccount': 'Kein Konto',
  'admin.users.tables.unknown': 'Unbekannt',
  'admin.users.tables.viewProfile': 'Profil anzeigen',
  // Search page translations
  'admin.users.search.title': 'Benutzersuche',
  'admin.users.search.subtitle': 'Benutzer nach verschiedenen Kriterien suchen und finden',
  'admin.users.search.form.userInfo.label': 'Benutzerinformationen',
  'admin.users.search.form.userInfo.placeholder': 'Suche nach Benutzername, Name, E-Mail oder Telefon...',
  'admin.users.search.form.country.label': 'Land',
  'admin.users.search.form.country.placeholder': 'Land auswählen...',
  'admin.users.search.form.country.all': 'Alle Länder',
  'admin.users.search.form.searchButton': 'Suchen',
  'admin.users.search.form.clearButton': 'Löschen',
  'admin.users.search.results.title': 'Suchergebnisse',
  'admin.users.search.results.noResults': 'Keine Benutzer gefunden, die Ihren Kriterien entsprechen',
  'admin.users.search.results.loading': 'Benutzer werden gesucht...',
  'admin.users.search.results.error': 'Fehler bei der Benutzersuche',
  'admin.users.search.results.showEmail': 'E-Mail anzeigen',
  'admin.users.search.results.hideEmail': 'E-Mail verbergen',
  'admin.users.search.results.showPhone': 'Telefon anzeigen',
  'admin.users.search.results.hidePhone': 'Telefon verbergen',
  'admin.users.search.results.columns.email': 'E-Mail',
  'admin.users.search.results.columns.phone': 'Telefon',
  
  // Profile page
  'admin.users.profile.title': 'Benutzerprofil',
  'admin.users.profile.subtitle': 'Detaillierte Benutzerinformationen und Einstellungen anzeigen',
  'admin.users.profile.error.userNotFound': 'Benutzer nicht gefunden. Der angegebene Benutzername existiert nicht.',
  'admin.users.profile.loading': 'Benutzerprofil wird geladen...',
  
  // Profile information section
  'admin.users.profile.info.title': 'Profilinformationen',
  'admin.users.profile.info.username': 'Benutzername',
  'admin.users.profile.info.name': 'Name',
  'admin.users.profile.info.status': 'Benutzerstatus',
  'admin.users.profile.info.memberSince': 'Mitglied seit',
  'admin.users.profile.info.sponsor': 'Sponsor',
  'admin.users.profile.info.referralLink': 'Empfehlungslink',
  'admin.users.profile.info.commissionModel': 'Provisionsmodell',
'admin.users.profile.info.country': 'Land',
  'admin.users.profile.info.domain': 'Domain',
  'admin.users.profile.info.internalCommissionModel': 'Internes Provisionsmodell',
  'admin.users.profile.info.communityLevel': 'Community-Ebene',
  'admin.users.profile.info.genealogyTree': 'Community-Stammbaum',
  'admin.users.profile.info.openUserTree': 'Benutzer-Baum öffnen',
  'admin.users.profile.info.copyReferralLink': 'Empfehlungslink kopieren',
  'admin.users.profile.info.viewSponsor': 'Sponsor-Profil anzeigen',
  'admin.users.profile.info.noData': 'Profilinformationen sind nicht verfügbar.',
  
  // Private information section
  'admin.users.profile.private.title': 'Private Informationen',
  'admin.users.profile.private.subtitle': 'Vertrauliche persönliche Daten des Benutzers',
  'admin.users.profile.private.email': 'E-Mail',
  'admin.users.profile.private.phone': 'Telefonnummer',
  'admin.users.profile.private.gender': 'Geschlecht',
  'admin.users.profile.private.noData': 'Private Informationen sind nicht verfügbar.',
  
  // Payment methods section
  'admin.users.profile.payment.title': 'Zahlungsmethoden',
  'admin.users.profile.payment.subtitle': 'Konfigurierte Zahlungsoptionen des Benutzers',
  'admin.users.profile.payment.crypto.title': 'Krypto-Wallet',
  'admin.users.profile.payment.crypto.network': 'Netzwerk',
  'admin.users.profile.payment.crypto.currency': 'Währung',
  'admin.users.profile.payment.crypto.address': 'Adresse',
  'admin.users.profile.payment.noData': 'Keine Zahlungsmethoden konfiguriert.',
  
  // User accounts section
  'admin.users.profile.accounts.title': 'Benutzerkonten',
  'admin.users.profile.accounts.subtitle': 'Trading-Konten und Investitionsdetails',
  'admin.users.profile.accounts.table.accountNumber': 'Kontonummer',
  'admin.users.profile.accounts.table.accountStatus': 'Kontostatus',
  'admin.users.profile.accounts.table.accountType': 'Kontotyp',
  'admin.users.profile.accounts.table.programPercent': 'Programm-Prozentsatz',
  'admin.users.profile.accounts.table.balance': 'Saldo',
  'admin.users.profile.accounts.table.creationDate': 'Kontenerstellung',
  'admin.users.profile.accounts.table.noData': 'Keine Kontodaten verfügbar',
  'admin.users.profile.accounts.table.error': 'Fehler beim Laden der Kontodaten',
  
  // User earnings section
  'admin.users.profile.earnings.title': 'Benutzer-Erträge Informationen',
  'admin.users.profile.earnings.subtitle': 'Umfassende Erträge- und Gewinnübersicht',
  'admin.users.profile.earnings.error': 'Fehler beim Laden der Ertragsdaten',
  'admin.users.profile.earnings.noData': 'Keine Ertragsdaten verfügbar',
  
  
  // Historic Earnings Section
  'admin.users.profile.historicEarnings.title': 'Historische Erträge-Informationen des Benutzers',
  'admin.users.profile.historicEarnings.subtitle': 'Vollständige historische Sicht auf Konten und Provisionserlöse',
  'admin.users.profile.historicEarnings.error.userIdRequired': 'Benutzer-ID erforderlich zum Laden der Ertragsdaten',
  'admin.users.profile.historicEarnings.accountsHistory.title': 'Konten-Gewinn-Verlauf',
  'admin.users.profile.historicEarnings.accountsHistory.subtitle': 'Historische Gewinnsdaten von Benutzer-Anlagekonten',
  'admin.users.profile.historicEarnings.accountsHistory.error': 'Fehler beim Laden des Konten-Gewinn-Verlaufs',
  'admin.users.profile.historicEarnings.commissionsHistory.title': 'Provisions-Erträge-Verlauf',
  'admin.users.profile.historicEarnings.commissionsHistory.subtitle': 'Historische Provisionserlöse aus Empfehlungsnetzwerk',
  'admin.users.profile.historicEarnings.commissionsHistory.error': 'Fehler beim Laden des Provisions-Erträge-Verlaufs',
  
  // Payment History Section
  'admin.users.profile.paymentHistory.title': 'Zahlungsverlauf des Benutzers',
  'admin.users.profile.paymentHistory.subtitle': 'Vollständige Aufzeichnung von Provisionszahlungen und Transaktionen',
  'admin.users.profile.paymentHistory.error.userIdRequired': 'Benutzer-ID erforderlich zum Laden der Zahlungsdaten',
  'admin.users.profile.paymentHistory.error.loadingData': 'Fehler beim Laden der Zahlungsverlauf-Daten',

  // Admin Community Levels
  'admin.users.communityLevels.title': 'Community-Ebenen',
  'admin.users.communityLevels.subtitle': 'Erkunde die Community-Struktur nach hierarchischen Ebenen',
  'admin.users.communityLevels.targetUser': 'Zielbenutzer',
  'admin.users.communityLevels.level': 'Ebene',
  'admin.users.communityLevels.members': 'Mitglieder',
  'admin.users.communityLevels.total': 'gesamt',
  'admin.users.communityLevels.active': 'Aktiv',
  'admin.users.communityLevels.inactive': 'Inaktiv',
  'admin.users.communityLevels.treeLevel': 'Baum-Ebene',
  'admin.users.communityLevels.directReferrals': 'Direkte Empfehlungen',
  'admin.users.communityLevels.memberSince': 'Mitglied Seit',
  'admin.users.communityLevels.username': 'Benutzername',
  'admin.users.communityLevels.name': 'Name',
  'admin.users.communityLevels.country': 'Land',
  'admin.users.communityLevels.joinDate': 'Beitrittsdatum',
  'admin.users.communityLevels.status': 'Status',
  'admin.users.communityLevels.loading': 'Lädt...',
  'admin.users.communityLevels.loadMore': 'Mehr Laden',
  'admin.users.communityLevels.noMembers': 'Keine Mitglieder für diese Ebene gefunden',
  'admin.users.communityLevels.errorLoading': 'Fehler beim Laden der Ebenendaten',
  'admin.users.communityLevels.errorLoadingData': 'Fehler beim Laden der Community-Daten',
  'admin.users.communityLevels.userNotFound': 'Benutzer nicht gefunden',
  'admin.users.communityLevels.noCommunityData': 'Keine Community-Daten verfügbar',
  'admin.users.communityLevels.filters': 'Filter',
  'admin.users.communityLevels.statusFilter': 'Status-Filter',
  'admin.users.communityLevels.rankFilter': 'Rang-Filter',
  'admin.users.communityLevels.allStatuses': 'Alle Status',
  'admin.users.communityLevels.allRanks': 'Alle Ränge',
  'admin.users.communityLevels.communityStructure': 'Community-Struktur',
};